import React from "react";
import "./CircleLoading.css";
function CircleLoading() {
  return (
    <div className="loading">
      <span className="loading__anim"></span>
    </div>
  );
}

export default CircleLoading;
